/* Daily verse, fallback list of 30 references.
 *
 * Used only when /api/home does not provide a devocional verse.
 * Rotation key is day-of-month modulo 30, so every calendar day maps to one.
 *
 * Verse texts are loaded lazily from bible-api.com the first time the card is
 * rendered; see fetchVerse() in lib/bible.js.
 */

export const DAILY_VERSE_REFS = [
  { ref: "João 3:16",           bookSlug: "joao",        chapter: 3,  verse: 16 },
  { ref: "Salmos 23:1",         bookSlug: "salmos",      chapter: 23, verse: 1  },
  { ref: "Romanos 8:28",        bookSlug: "romanos",     chapter: 8,  verse: 28 },
  { ref: "Filipenses 4:13",     bookSlug: "filipenses",  chapter: 4,  verse: 13 },
  { ref: "Jeremias 29:11",      bookSlug: "jeremias",    chapter: 29, verse: 11 },
  { ref: "Isaías 41:10",        bookSlug: "isaias",      chapter: 41, verse: 10 },
  { ref: "2 Coríntios 4:7",     bookSlug: "2corintios",  chapter: 4,  verse: 7  },
  { ref: "Salmos 46:1",         bookSlug: "salmos",      chapter: 46, verse: 1  },
  { ref: "Provérbios 3:5",      bookSlug: "proverbios",  chapter: 3,  verse: 5  },
  { ref: "Mateus 6:33",         bookSlug: "mateus",      chapter: 6,  verse: 33 },
  { ref: "Romanos 12:2",        bookSlug: "romanos",     chapter: 12, verse: 2  },
  { ref: "Efésios 2:8",         bookSlug: "efesios",     chapter: 2,  verse: 8  },
  { ref: "Salmos 91:1",         bookSlug: "salmos",      chapter: 91, verse: 1  },
  { ref: "João 14:6",           bookSlug: "joao",        chapter: 14, verse: 6  },
  { ref: "Romanos 8:38",        bookSlug: "romanos",     chapter: 8,  verse: 38 },
  { ref: "Hebreus 11:1",        bookSlug: "hebreus",     chapter: 11, verse: 1  },
  { ref: "Tiago 1:2",           bookSlug: "tiago",       chapter: 1,  verse: 2  },
  { ref: "1 Coríntios 10:13",   bookSlug: "1corintios",  chapter: 10, verse: 13 },
  { ref: "Filipenses 4:6",      bookSlug: "filipenses",  chapter: 4,  verse: 6  },
  { ref: "Salmos 27:1",         bookSlug: "salmos",      chapter: 27, verse: 1  },
  { ref: "Isaías 40:31",        bookSlug: "isaias",      chapter: 40, verse: 31 },
  { ref: "Mateus 11:28",        bookSlug: "mateus",      chapter: 11, verse: 28 },
  { ref: "João 15:5",           bookSlug: "joao",        chapter: 15, verse: 5  },
  { ref: "Romanos 5:8",         bookSlug: "romanos",     chapter: 5,  verse: 8  },
  { ref: "Efésios 3:20",        bookSlug: "efesios",     chapter: 3,  verse: 20 },
  { ref: "Salmos 37:4",         bookSlug: "salmos",      chapter: 37, verse: 4  },
  { ref: "Provérbios 31:25",    bookSlug: "proverbios",  chapter: 31, verse: 25 },
  { ref: "1 Pedro 5:7",         bookSlug: "1pedro",      chapter: 5,  verse: 7  },
  { ref: "Apocalipse 21:4",     bookSlug: "apocalipse",  chapter: 21, verse: 4  },
  { ref: "Lamentações 3:23",    bookSlug: "lamentacoes", chapter: 3,  verse: 23 },
];

/** Returns one of the 30 refs based on the current day of the month. */
export function getDailyVerseRef(date = new Date()) {
  const dom = date.getDate(); // 1..31
  return DAILY_VERSE_REFS[(dom - 1) % DAILY_VERSE_REFS.length];
}
